import { cn } from '@verlo/shared/lib/utils';

/**
 * The one filter row (Back Office Review, wave A): search on the left, a Segmented for the
 * period, Selects for the rest, a count or an action on the right. Wraps predictably at
 * narrow widths instead of each page laying its own out.
 *
 *   <FilterBar right={<span>21 people</span>}>
 *     <Input placeholder="Search staff…" className="w-64" />
 *     <Select … />
 *   </FilterBar>
 */
const FilterBar = ({ children, right, className, testId }) => (
  <div className={cn('mb-4 flex flex-wrap items-center gap-2', className)} data-testid={testId}>
    {children}
    {right && <div className="ml-auto flex items-center gap-2 text-[13px] text-ink-soft">{right}</div>}
  </div>
);

export default FilterBar;
